import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    transferencias: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_IMPORT' (state) {
        state.transferencias = [];
    },
    'SET_TRANSFERENCIAS'(state, transferencias) {
        state.transferencias = transferencias.map(transferencia => ({
            ...transferencia,
            _rowVariant: (/true/i).test(transferencia.error)? 'danger' : '',
            detailShowing: true  
        })) ;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_IMPORT');
            resolve();
        })            
    },
    importarReporte ( { commit }, file ) {
        return new Promise((resolve, reject) => {
            let error;
            let fileName = file.name;
            let fileExtension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
            let fileSize = parseFloat(file.size / 1048576);

            if (fileExtension != 'csv') {
                    error = 'El tipo de archivo seleccionado no es válido. Sólo se permiten archivos de tipo csv.';
            }

            // if (fileSize >= 1 ) {
            //     error = 'El archivo seleccionado tiene un peso mayor al permitido. Sólo se permiten imágenes de hasta 1MB.';
            // }

            if (error) {
                reject(error);
            } else {
				let formData = new FormData();
                formData.append('file', file);

                let options = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }				

				apiAxios.post('edi/import/transferencias/file', formData, options)
                    .then(res => {
                        commit('SET_TRANSFERENCIAS', res.data);
                        resolve();
                    })
					.catch(error => reject(helpers.methods.getErrorMessage(error)));
			}
        })
    },	
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = false;
            
            if (state.transferencias) {
                if (state.transferencias.length != 0) {
                    save = true;
                }
            }

            if (save) {
                let list= {
                    transferencias: state.transferencias
                }

                apiAxios.post('edi/import/transferencias', list)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject('No existen transferencias para registrar');
            }
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}